import { PageContent } from '../content/pages';

type CommonQuestionsProps = {
  commonQuestions?: PageContent['commonQuestions'];
};

const CommonQuestions = ({ commonQuestions }: CommonQuestionsProps) => {
  // Get the first question
  const firstQuestion = commonQuestions?.questions?.[0];

  // If there's no question, don't render anything
  if (!firstQuestion) {
    return null;
  }

  return (
    <div className="bg-white py-16">
      <div className="container mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-semibold text-gray-900 text-center mb-12">
          Common questions
        </h2>
        <div className="w-full max-w-[1080px] flex flex-col gap-10 mx-auto">
          <div className="flex flex-col">
            <h3 className="text-xl text-gray-900 font-medium mb-4">
              {firstQuestion.question}
            </h3>
            <p className="text-sm text-gray-900 mb-4">
              {firstQuestion.answer}
            </p>
            <div className="h-px bg-gray-200" />
          </div>

          <div className="flex flex-col">
            <h3 className="text-xl text-gray-900 font-medium mb-4">
              How do I get paid?
            </h3>
            <p className="text-sm text-gray-900 mb-4">
              When a ticket is purchased, the sales amount minus the fee is immediately transferred.
            </p>
            <div className="h-px bg-gray-200" />
          </div>

          <div className="flex flex-col">
            <h3 className="text-xl text-gray-900 font-medium mb-4">
              Is there a limit to how many tickets I can sell?
            </h3>
            <p className="text-sm text-gray-900 mb-4">
              No limits - create unlimited events with unlimited tickets. Scale your events as needed.
            </p>
            <div className="h-px bg-gray-200" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommonQuestions; 